export default __webpack_public_path__ + "static/media/thumbs-up-grey.2a51681a.svg";